import jwt from "jsonwebtoken";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  isJsonString,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const pluginCategory = {
  state: {
    listPluginCategory: [],
    position: 0,
    total: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getPluginCategory(payload = {}, rootState) {
      if (payload) payload.sort = [["createdAt", "DESC"]];
      let url =
        DomainAPI + Channel + "/api/secure/pluginCategories/getCategories";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 1 && Array.isArray(result.data.list)) {
            let listPluginCategory = result.data.list.map((e) => {
              if (e.name && isJsonString(e.name)) e.name = JSON.parse(e.name);
              return e;
            });
            this.setState({
              listPluginCategory: listPluginCategory,
              total: result.data.total,
              count: result.data.count,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async insertPluginCategory(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/pluginCategories/insertPluginCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updatePluginCategory(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/pluginCategories/updatePluginCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deletePluginCategory(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/pluginCategories/deletePluginCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ categoryIds: payload.categoryIds }),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          // if(result.code) {
          //     dispatch.products.getListProduct(rootState)
          // }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
  // subscriptions: {
  //     'PluginCategory/deleteMenuGroup': (action, state, unsubscribe) => {
  //         console.log("***********************subscriptions");
  //         dispatch.products.setState({})
  //         console.log(action);
  //         console.log(state);
  //     //   dispatch.settings.set(action.payload)
  //     }
  // }
};

export default pluginCategory;
